import styled from 'styled-components';
import { when } from 'utils';

export const Dropdown = styled.ul`
  position: absolute;
  max-height: 0;
  overflow-y: auto;
  z-index: 10;

  top: 0;
  left: 0;
  right: 0;

  list-style: none;
  padding: 0;
  margin: 0;
  background: #fff;
  outline: 2px solid #dddddd;
  border-radius: 2.35rem;

  scrollbar-width: thin;
  scrollbar-color: #ddd transparent;
`;

export const Container = styled.div`
  background: #fff;
  padding: 1.5rem 2.5rem;
  border-radius: 3rem;
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;

  > * {
    flex-shrink: 0;
  }

  ${when('open')`
    > ${Dropdown} {
      max-height: 40rem;
    }
  `}
`;

export const Content = styled.div`
  flex-grow: 1;
  width: 50%;
  font-weight: bold;
  font-size: 1.6rem;
`;

export const Arrow = styled.div`
  width: 0;
  height: 0;
  border-left: 0.5rem solid transparent;
  border-right: 0.5rem solid transparent;

  border-top: 0.8rem solid #767676;
`;
